declare global {
  interface Window {
    __env?:{[key:string] : any;}
  }
}
export const environment = window.__env || {};